import { useEffect } from 'react';

export default function PodcastPlayer() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.buzzsprout.com/2504904/episodes/17215727-2047-is-not-a-spectator-sport-why-india-needs-your-story.js?container_id=buzzsprout-player-17215727&player=small';
    script.async = true;
    script.charset = 'utf-8';
    document.getElementById('buzzsprout-player-17215727')?.appendChild(script);
  }, []);

  return <div id="buzzsprout-player-17215727" />;
}

